/**
 * ScoreDashboard Suspend must only change from the Suspend toggle.
 * Runs/Rate/cron/full-row socket blasts always include isSuspended and were
 * flipping the toggle whenever the line matched (lineMoved=false hole).
 */

/** @deprecated line move heuristic — kept for tests; prefer ignoreSocketSuspend. */
export function lineFieldsMoved(opts: {
  data: Record<string, unknown>
  curRateBack?: number
  curRateLay?: number
  curHorseBack?: number
  curHorseLay?: number
}): boolean {
  const { data } = opts
  const ratesMoved =
    (data.rateBack != null && Number(data.rateBack) !== Number(opts.curRateBack)) ||
    (data.rateLay != null && Number(data.rateLay) !== Number(opts.curRateLay))
  const horsesMoved =
    (data.horseBack != null && Number(data.horseBack) !== Number(opts.curHorseBack)) ||
    (data.horseLay != null && Number(data.horseLay) !== Number(opts.curHorseLay))
  return ratesMoved || horsesMoved
}

/**
 * Socket frames never change Suspend — return the current UI value.
 * Explicit Suspend toggle / its HTTP response is the only writer.
 */
export function nextSuspendFromSocketFrame(
  currentSuspended: boolean | undefined,
  _incomingSuspended?: unknown,
  _lineMoved?: boolean,
): boolean {
  return Boolean(currentSuspended)
}
